import React, {useEffect, useState} from "react";
import Toolbar from "@mui/material/Toolbar";
import {ButtonSX} from "../App.styles";
import {AppBar, Box, Button, Menu, MenuItem, IconButton} from "@mui/material";
import { makeStyles } from '@mui/styles';
import {useNavigate, useLocation} from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import logo from '../imaginiSite/logo2.png';

const useStyles = makeStyles({
    popOverRoot: {
        pointerEvents: "none"
    }
});


export const Appbar = ({refs}) => {

    const navigate = useNavigate();

    const {acasaRef, serviciiRef, despreRef, proiecteRef, contactRef} = refs;

    const [activeSection, setActiveSection] = useState(useLocation().pathname === '/pagina-proiecte' ? null : 'Acasa');

    // Compact mode for narrow width OR short height (landscape phones/tablets)
    const isNarrow = useMediaQuery('(max-width:900px)');
    const isShort = useMediaQuery('(max-height:500px)');
    const isCompact = isNarrow || isShort;

    let currentlyHovering = false;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const [mobileMenuEl, setMobileMenuEl] = useState(null);

    const classes = useStyles();

    function handleClick(event) {
        if (anchorEl !== event.currentTarget) {
            setAnchorEl(event.currentTarget);
        }
    }

    function handleHover() {
        currentlyHovering = true;
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleCloseHover() {
        currentlyHovering = false;
        setTimeout(() => {
            if (!currentlyHovering) {
                handleClose();
            }
        }, 10);
    }


    useEffect(() => {
        const handleScroll = () => {
            const sections = [acasaRef, serviciiRef, despreRef, proiecteRef, contactRef];
            const labels = ['Acasa', 'Servicii', 'Despre', 'Proiecte', 'Contact'];

            sections.forEach((section, index) => {
                if (section.current) {
                    const {top} = section.current.getBoundingClientRect();
                    if (top <= 64) {
                        setActiveSection(labels[index]);
                    }
                }
            });
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);

    }, [acasaRef, serviciiRef, despreRef, proiecteRef, contactRef]);

    const getButtonStyle = (section) => ({
        ...ButtonSX,
        color: activeSection === section ? '#00ADB5' : '#EEEEEE'
    });

    const navigateToSection = (ref, section, offset = 0) => {
        setActiveSection(section);

        if (window.location.pathname === '/' || window.location.hash.includes('#/')) {
            window.scrollTo({
                top: ref.current.offsetTop - offset,
                behavior: 'smooth'
            });
        } else {
            navigate('/');
            setTimeout(() => {
                window.scrollTo({
                    top: ref.current.offsetTop - offset,
                    behavior: 'smooth'
                });
            }, 100);
        }
    };

    const openMobileMenu = (e) => setMobileMenuEl(e.currentTarget);
    const closeMobileMenu = () => setMobileMenuEl(null);

    const mobileItems = [
        { label: 'Acasa', action: () => navigateToSection(acasaRef, 'Acasa') },
        { label: 'Servicii', action: () => navigateToSection(serviciiRef, 'Servicii') },
        { label: 'Despre', action: () => navigateToSection(despreRef, 'Despre', 63) },
        { label: 'Proiecte', action: () => navigateToSection(proiecteRef, 'Proiecte') },
        { label: 'Galerie Proiecte', action: () => { navigate('/pagina-proiecte'); } },
        { label: 'Contact', action: () => navigateToSection(contactRef, 'Contact') },
    ];

    return <div>
        <AppBar position="fixed" sx={{backgroundColor: '#222831'}}>
            <Toolbar sx={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', minHeight: isCompact ? 56 : 64}}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    height: isCompact ? '56px' : '64px',
                    width: { xs: 'auto', sm: '360px' },
                    pl: isCompact ? 2 : 3,   // more inner space on the left when not compact
                    ml: 0                    // remove the negative margin
                }}>
                    <img
                        src={logo}
                        alt="logo AllPro Service"
                        style={{width: isCompact ? '200px' : '300px', height: isCompact ? '36px' : '53px', cursor: 'pointer'}}
                        onClick={() => navigateToSection(acasaRef)}
                    />
                </Box>

                {isCompact ? (
                    <>
                        <IconButton color="inherit" onClick={openMobileMenu} aria-label="open navigation menu">
                            <MenuIcon />
                        </IconButton>
                        <Menu anchorEl={mobileMenuEl} open={Boolean(mobileMenuEl)} onClose={closeMobileMenu}>
                            {mobileItems.map((item) => (
                                <MenuItem key={item.label} onClick={() => { closeMobileMenu(); item.action(); }}>
                                    {item.label}
                                </MenuItem>
                            ))}
                        </Menu>
                    </>
                ) : (
                    <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        flexGrow: 1,
                        justifyContent: {xs: 'center', sm: 'flex-end'}
                    }}>
                        {['Acasa', 'Servicii'].map((section) => (
                            <Button
                                key={section}
                                sx={getButtonStyle(section)}
                                onClick={() => navigateToSection(refs[section.toLowerCase() + 'Ref'], section)}
                            >
                                {section}
                            </Button>
                        ))}

                        <Button
                            key="Despre"
                            sx={getButtonStyle('Despre')}
                            onClick={() => navigateToSection(despreRef, 'Despre', 63)}
                        >
                            Despre
                        </Button>

                        <Button
                            key="Proiecte"
                            sx={getButtonStyle('Proiecte')}
                            aria-owns={anchorEl ? "simple-menu" : undefined}
                            aria-haspopup="true"
                            onClick={() => navigateToSection(proiecteRef)}
                            onMouseOver={handleClick}
                            onMouseLeave={handleCloseHover}
                        >
                            Proiecte
                        </Button>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                onMouseEnter: handleHover,
                                onMouseLeave: handleCloseHover,
                                style: {pointerEvents: "auto"}
                            }}
                            PopoverClasses={{
                                root: classes.popOverRoot
                            }}
                            disableScrollLock={true}
                        >
                            <MenuItem onClick={() => {
                                window.location.href = '/pagina-proiecte';
                                handleClose();

                            }}>
                                <a href={'/pagina-proiecte'} style={{textDecoration: 'none', color: '#222831'}}>
                                    Galerie Proiecte
                                </a>
                            </MenuItem>
                        </Menu>


                        <Button
                            key="Contact"
                            sx={getButtonStyle('Contact')}
                            onClick={() => navigateToSection(refs.contactRef)}
                        >
                            Contact
                        </Button>
                    </Box>
                )}
            </Toolbar>
        </AppBar>
    </div>
}
